import React, { Component } from "react";
import { Form } from 'react-bootstrap';

interface IValidatableFormGroupProps {
    label: string,
    value: string,
    className?: string,
    style?: any,
    placeholder?: string,
    validated: boolean,
    validationError: string,
    maxLength?: number,
    disabled?: boolean,
    inputColumns?: number,
    isChild?: boolean,
    onChange?: (e: any) => void,
    onBlur?: (e: any) => void,
    pattern?: string,
    inputmode?: 'none' | 'text' | 'tel' | 'url' | 'email' | 'numeric' | 'decimal' | 'search',
    rowsCount: number,
    autoComplete?: string,
    name?: string
}

export class ValidatableFormGroup extends React.Component<IValidatableFormGroupProps> {
    constructor(props: IValidatableFormGroupProps) {
        super(props);
    }

    render() {
        return (
            <Form.Group className={this.props.className} style={this.props.style}>
                <Form.Label>{this.props.label}</Form.Label>

                {this.props.rowsCount > 0 ? (
                    <Form.Control
                        as="textarea"
                        rows={this.props.rowsCount}
                        onChange={(e) => this.props.onChange && this.props.onChange(e)}
                        onBlur={(e) => this.props.onBlur && this.props.onBlur(e)}
                        value={!!this.props.value ? this.props.value : ""}
                        placeholder={this.props.placeholder}
                        maxLength={this.props.maxLength}
                        disabled={this.props.disabled}
                        className={this.props.validated ? (this.props.validationError ? "is-invalid" : "is-valid") : ""}
                        inputMode='text'
                        autoComplete={this.props.autoComplete}
                        name={this.props.name}
                    />
                ) : (
                    <Form.Control
                        onChange={(e) => this.props.onChange && this.props.onChange(e)}
                        onBlur={(e) => this.props.onBlur && this.props.onBlur(e)}
                        value={!!this.props.value ? this.props.value : ""}
                        placeholder={this.props.placeholder}
                        maxLength={this.props.maxLength}
                        disabled={this.props.disabled}
                        className={this.props.validated ? (this.props.validationError ? "is-invalid" : "is-valid") : ""}
                        pattern={this.props.pattern}
                        inputMode={this.props.inputmode}
                        autoComplete={this.props.autoComplete}
                        name={this.props.name}
                    />
                )}

                {this.props.validated && this.props.validationError ? (
                    <Form.Control.Feedback type="invalid">
                        {this.props.validationError}
                    </Form.Control.Feedback>
                ) : null}
            </Form.Group>
        );
    }
}

export default ValidatableFormGroup;